
export const observerSection = (contentSections: NodeListOf<HTMLElement>, navLinks: NodeListOf<HTMLAnchorElement>) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const id: string | null = entry.target.getAttribute('id')
            const linkActive: HTMLAnchorElement | null = document.querySelector(`.subMenu-link[href="#${id}"]`)
            
            if (entry.isIntersecting) {
                navLinks.forEach(link => link.classList.remove('active'))
                linkActive?.classList.add('active')
            }
        })
    }, {
        root: null,
        threshold: 0.8,
    })

    contentSections.forEach(section => observer.observe(section))
}